var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('OnAirInfoBoxShow',{attrs:{"show":_vm.show,"media":_vm.currentMedia}}),_c('OnAirInfoBoxSong',{attrs:{"present":_vm.present}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }